import { hasSlotContent as e } from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { createCommentVNode as n, createElementBlock as r, createElementVNode as i, normalizeClass as a, normalizeStyle as o, openBlock as s, renderSlot as c } from "vue";
//#region components/card/card.vue
var l = {
	compatConfig: { MODE: 3 },
	name: "DtCard",
	props: {
		maxHeight: {
			type: String,
			default: null
		},
		containerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		contentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		headerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		footerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	data() {
		return { hasSlotContent: e };
	}
};
function u(e, t, l, u, d, f) {
	return s(), r("div", {
		class: a(["d-card", l.containerClass]),
		"data-qa": "dt-card"
	}, [
		d.hasSlotContent(e.$slots.header) ? (s(), r("div", {
			key: 0,
			class: a(["d-card__header", l.headerClass])
		}, [c(e.$slots, "header")], 2)) : n("", !0),
		i("div", {
			class: a(["d-card__content", l.contentClass]),
			style: o({ "max-height": l.maxHeight })
		}, [c(e.$slots, "content")], 6),
		d.hasSlotContent(e.$slots.footer) ? (s(), r("div", {
			key: 1,
			class: a(["d-card__footer", l.footerClass])
		}, [c(e.$slots, "footer")], 2)) : n("", !0)
	], 2);
}
var d = /* @__PURE__ */ t(l, [["render", u]]);
//#endregion
export { d as default };

//# sourceMappingURL=card.js.map